module.exports = __webpack_public_path__ + "assets/img/eyes-idle.97451503.png";